import { cbSemanticCssVars } from '@creditornot/cb-ingredients';
import React from 'react';
import { useMemo } from 'react';
import styled, { CSSProperties } from 'styled-components';

import { CategoryRow } from './CategoryRow';
import { OfferRow } from './OfferRow';
import { SharedMenuElement } from '../../../SharedMenuEditorPage/types';
import { OfferDraftChanges } from '../../useOfferDraftChanges';

export type ListRowRendererProps = {
  index: number;
  data: {
    itemList: SharedMenuElement[];
    primaryLanguage: Language;
    offerDraftChanges: OfferDraftChanges;
    onDetachOfferImage: (offerId: string, deleteAt: number) => Promise<void>;
  };
  style: CSSProperties;
};

export const ItemWrapper = styled.div`
  border-block-end: 1px solid ${cbSemanticCssVars.borderPrimary};
`;

export const ListRowRenderer = ({
  index,
  data: { itemList, primaryLanguage, offerDraftChanges, onDetachOfferImage },
  style,
}: ListRowRendererProps) => {
  const element = useMemo(() => itemList[index], [itemList, index]);

  if (element.type === 'item') {
    const draftOffer = {
      ...element.itemState,
      ...offerDraftChanges[element.itemState.id],
    };

    return (
      <ItemWrapper style={style}>
        <OfferRow
          offer={draftOffer}
          primaryLanguage={primaryLanguage}
          onDetachImage={deleteAt => onDetachOfferImage(element.itemState.id, deleteAt)}
        />
      </ItemWrapper>
    );
  }

  if (element.type === 'category-subheader' || element.type === 'subcategory-subheader') {
    return (
      <ItemWrapper style={style}>
        <CategoryRow
          category={element.category}
          parentCategory={element.parentCategory}
          primaryLanguage={primaryLanguage}
        />
      </ItemWrapper>
    );
  }

  return null;
};
